import { postForm } from '@/shared/api/client';
import { submitForm } from '@/shared/api/submit';
import { getListRows } from '@/shared/lib/pagination';

export interface Work extends Record<string, unknown> {
  id: number;
  name: string;
  alias?: string;
  title?: string;
  icon?: string;
  is_active?: number;
  parent_id?: number | null;
  /** The legacy API key contains a Cyrillic "с". */
  'has_сhildren'?: boolean | number;
  has_children?: boolean | number;
}

export interface WorkFormValues {
  name: string;
  alias: string;
  title: string;
  icon: string;
  isActive: number;
}

type ListResponse = Record<string, unknown>;

export const hasChildren = (work: Work) => Boolean(work['has_сhildren'] ?? work.has_children);

export async function fetchWorkSections() {
  const res = await postForm<ListResponse>('/work_type_offer/get-sections/');
  return getListRows<Work>(res, ['work_type_offers']);
}

export async function fetchWorkChildren(parentId: number) {
  const res = await postForm<ListResponse>('/work_type_offer/get-children/', { parent_id: parentId });
  return getListRows<Work>(res, ['work_type_offers']);
}

export async function fetchWork(id: number) {
  const res = await postForm<{ work_type_offer: Work }>('/work_type_offer/view/', { id });
  return res.work_type_offer;
}

const toFields = (v: WorkFormValues) => ({
  name: v.name,
  alias: v.alias,
  title: v.title,
  icon: v.icon,
  is_active: v.isActive,
});

/** `parentId` 0 creates a section. */
export const createWork = (parentId: number, values: WorkFormValues) =>
  submitForm('/work_type_offer/create/', { ...toFields(values), parent_id: parentId });

export const editWork = (id: number, values: WorkFormValues) =>
  submitForm('/work_type_offer/edit/', { ...toFields(values), id });

/** `newParentId` 0 makes the work a section. */
export const moveWork = (id: number, newParentId: number) =>
  submitForm('/work_type_offer/move/', { id, parent_id: newParentId });

export const deleteWork = (id: number) => submitForm('/work_type_offer/delete/', { ids: [id] });
